import React from "react";
import { Doughnut } from "react-chartjs-2";
import { colors } from "../../utils";

interface PieChartOptions {
  data: any[];
  labels: string[];
}

export const PieChart: React.FC<PieChartOptions> = (props) => {
  const { data, labels } = props;

  return (
    <Doughnut
      data={{
        labels,
        datasets: [
          {
            data,
            backgroundColor: colors.slice(0, data.length),
          },
        ],
      }}
      options={{
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false,
          },
        },
      }}
    />
  );
};
